var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workflow-tooltip-wrapper"},[_c('div',{ref:"tooltip",staticClass:"workflow-tooltip-content",class:{ active: _vm.isTooltipVisible }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }